import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import './ImpactModal.css';

// Professional SVG Icons
const BookIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 19.5C4 18.837 4.263 18.201 4.732 17.732C5.201 17.263 5.837 17 6.5 17H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M6.5 2H20V20H6.5C5.837 20 5.201 19.737 4.732 19.268C4.263 18.799 4 18.163 4 17.5V4.5C4 3.837 4.263 3.201 4.732 2.732C5.201 2.263 5.837 2 6.5 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 7H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    <path d="M8 10H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

const WaterDropIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2.69L5 12.19C5 16.26 8.13 19.5 12 19.5C15.87 19.5 19 16.26 19 12.19L12 2.69Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 2.69V19.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const HouseIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5304 5.21071 21.0391 5.58579 21.4142C5.96086 21.7893 6.46957 22 7 22H17C17.5304 22 18.0391 21.7893 18.4142 21.4142C18.7893 21.0391 19 20.5304 19 20V10M19 10L21 12M9 22V16C9 15.4696 9.21071 14.9609 9.58579 14.5858C9.96086 14.2107 10.4696 14 11 14H13C13.5304 14 14.0391 14.2107 14.4142 14.5858C14.7893 14.9609 15 15.4696 15 16V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const HeartIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.84 4.61C20.3292 4.099 19.7228 3.69364 19.0554 3.41708C18.3879 3.14052 17.6725 2.99817 16.95 2.99817C16.2275 2.99817 15.5121 3.14052 14.8446 3.41708C14.1772 3.69364 13.5708 4.099 13.06 4.61L12 5.67L10.94 4.61C9.9083 3.57831 8.50903 2.99871 7.05 2.99871C5.59096 2.99871 4.19169 3.57831 3.16 4.61C2.1283 5.64169 1.54871 7.04097 1.54871 8.5C1.54871 9.95903 2.1283 11.3583 3.16 12.39L4.22 13.45L12 21.23L19.78 13.45L20.84 12.39C21.351 11.8792 21.7564 11.2728 22.0329 10.6054C22.3095 9.93789 22.4518 9.22248 22.4518 8.5C22.4518 7.77752 22.3095 7.0621 22.0329 6.39464C21.7564 5.72718 21.351 5.12075 20.84 4.61Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const SparkleIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L13.09 8.26L19 9L13.09 9.74L12 16L10.91 9.74L5 9L10.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M19 19L19.5 21.5L22 22L19.5 22.5L19 25L18.5 22.5L16 22L18.5 21.5L19 19Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const GiftIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 12V20C20 20.5304 19.7893 21.0391 19.4142 21.4142C19.0391 21.7893 18.5304 22 18 22H6C5.46957 22 4.96086 21.7893 4.58579 21.4142C4.21071 21.0391 4 20.5304 4 20V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 7H2V12H22V7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 22V7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 7H7.5C6.57174 7 5.6815 6.63125 5.02513 5.97487C4.36875 5.3185 4 4.42826 4 3.5C4 2.57174 4.36875 1.6815 5.02513 1.02513C5.6815 0.36875 6.57174 0 7.5 0C11 0 12 7 12 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 7H16.5C17.4283 7 18.3185 6.63125 18.9749 5.97487C19.6312 5.3185 20 4.42826 20 3.5C20 2.57174 19.6312 1.6815 18.9749 1.02513C18.3185 0.36875 17.4283 0 16.5 0C13 0 12 7 12 7Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const StarIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

interface ImpactModalProps {
  onClose: () => void;
}

const ImpactModal: React.FC<ImpactModalProps> = ({ onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleDonateClick = () => {
    onClose();
    setTimeout(() => {
      navigate('/donate-anonymously');
    }, 300);
  };

  return (
    <div className="impact-modal-overlay" onClick={onClose}>
      <div className="impact-modal" onClick={(e) => e.stopPropagation()}>
        <div className="impact-modal-header">
          <h2>{t('home.impactModal.title')}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="impact-modal-content">
          <div className="impact-intro">
            <p className="impact-intro-text">{t('home.impactModal.intro')}</p>
          </div>

          <div className="impact-stats-grid">
            <div className="impact-stat-card">
              <div className="impact-stat-icon">
                <BookIcon />
              </div>
              <div className="impact-stat-number">15,000+</div>
              <div className="impact-stat-label">{t('home.impactModal.stats.childrenEducated')}</div>
              <div className="impact-stat-description">{t('home.impactModal.stats.childrenEducatedDesc')}</div>
            </div>

            <div className="impact-stat-card">
              <div className="impact-stat-icon">
                <WaterDropIcon />
              </div>
              <div className="impact-stat-number">50+</div>
              <div className="impact-stat-label">{t('home.impactModal.stats.waterProjects')}</div>
              <div className="impact-stat-description">{t('home.impactModal.stats.waterProjectsDesc')}</div>
            </div>

            <div className="impact-stat-card">
              <div className="impact-stat-icon">
                <HouseIcon />
              </div>
              <div className="impact-stat-number">2,500+</div>
              <div className="impact-stat-label">{t('home.impactModal.stats.familiesSheltered')}</div>
              <div className="impact-stat-description">{t('home.impactModal.stats.familiesShelteredDesc')}</div>
            </div>

            <div className="impact-stat-card">
              <div className="impact-stat-icon">
                <HeartIcon />
              </div>
              <div className="impact-stat-number">100,000+</div>
              <div className="impact-stat-label">{t('home.impactModal.stats.livesTouched')}</div>
              <div className="impact-stat-description">{t('home.impactModal.stats.livesTouchedDesc')}</div>
            </div>
          </div>

          <div className="impact-stories">
            <h3>{t('home.impactModal.stories.title')}</h3>
            <div className="impact-story-list">
              <div className="impact-story-item">
                <div className="story-icon">
                  <SparkleIcon />
                </div>
                <div className="story-content">
                  <h4>{t('home.impactModal.stories.story1.title')}</h4>
                  <p>{t('home.impactModal.stories.story1.text')}</p>
                </div>
              </div>

              <div className="impact-story-item">
                <div className="story-icon">
                  <GiftIcon />
                </div>
                <div className="story-content">
                  <h4>{t('home.impactModal.stories.story2.title')}</h4>
                  <p>{t('home.impactModal.stories.story2.text')}</p>
                </div>
              </div>

              <div className="impact-story-item">
                <div className="story-icon">
                  <StarIcon />
                </div>
                <div className="story-content">
                  <h4>{t('home.impactModal.stories.story3.title')}</h4>
                  <p>{t('home.impactModal.stories.story3.text')}</p>
                </div>
              </div>
            </div>
          </div>

          <div className="impact-cta">
            <h3>{t('home.impactModal.cta.title')}</h3>
            <p>{t('home.impactModal.cta.description')}</p>
            <div className="impact-cta-buttons">
              <button className="impact-button-primary" onClick={handleDonateClick}>
                {t('home.impactModal.cta.donate')}
              </button>
              <button className="impact-button-secondary" onClick={onClose}>
                {t('home.impactModal.cta.close')}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpactModal;

